import React from "react";
import { Link } from "react-router-dom";
import { Users, Sword, ArrowLeft } from "lucide-react";

const DualCalculatorsNav = () => {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-8">
      <div className="rounded-2xl bg-gradient-to-b from-[#C9A96A]/[0.05] to-transparent border border-[#C9A96A]/15 p-4 sm:p-5">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#C9A96A]/15 border border-[#C9A96A]/25 flex items-center justify-center">
            <Sword className="w-4 h-4 text-[#D4B98A]" />
          </div>
          <div>
            <div className="text-white font-bold text-sm">حاسبات العجلات المزدوجة</div>
            <div className="text-white/50 text-[11px]">صفحات مستقلة مع خطة موصى بها رسمية</div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Link
            to="/dual-characters"
            className="group flex items-center gap-3 rounded-xl bg-white/[0.03] hover:bg-white/[0.06] border border-white/10 hover:border-[#C9A96A]/40 p-3.5 transition-colors"
          >
            <div className="w-10 h-10 rounded-lg bg-[#8B5CF6]/15 border border-[#8B5CF6]/30 flex items-center justify-center">
              <Users className="w-5 h-5 text-[#B197F0]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-white font-bold text-sm">الشخصيات الأسطورية</div>
              <div className="text-white/50 text-[11px]">10 سحبات • 12/20 عنصر</div>
            </div>
            <ArrowLeft className="w-4 h-4 text-white/40 group-hover:text-[#E5CB94] transition-colors" />
          </Link>

          <Link
            to="/dual-weapons"
            className="group flex items-center gap-3 rounded-xl bg-white/[0.03] hover:bg-white/[0.06] border border-white/10 hover:border-[#C9A96A]/40 p-3.5 transition-colors"
          >
            <div className="w-10 h-10 rounded-lg bg-[#DC2626]/15 border border-[#DC2626]/30 flex items-center justify-center">
              <Sword className="w-5 h-5 text-[#F87171]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-white font-bold text-sm">الأسلحة الأسطورية</div>
              <div className="text-white/50 text-[11px]">10 سحبات • 11/20 عنصر</div>
            </div>
            <ArrowLeft className="w-4 h-4 text-white/40 group-hover:text-[#E5CB94] transition-colors" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DualCalculatorsNav;
